import { Outlet, createFileRoute } from '@tanstack/react-router';

import { useSyncTenantFromParams } from '@/context/organization-context';

/**
 * Org-level tenant layout. Org-scoped pages (settings, clients list) live
 * directly under this; client-scoped pages nest one level deeper under
 * `c/$clientId`. Syncs the org from the URL into context (client left untouched
 * here; the nested client layout syncs that).
 */
export const Route = createFileRoute('/_authed/dashboard/o/$orgId')({
  component: OrgLayout,
});

function OrgLayout() {
  const { orgId } = Route.useParams();
  useSyncTenantFromParams(orgId);
  return <Outlet />;
}
